import { createStore } from 'owa-satcheljs';
import type UserPremiumStatusStore from './schema/UserPremiumStatusStore';

const getStore: () => UserPremiumStatusStore = createStore<UserPremiumStatusStore>(
    'userPremiumStatusStore',
    {
        userPremiumStatus: false,
    }
);

export default getStore;
